import { useMemo, useState, useEffect } from "react";

type CellState = {
  isActive: boolean;
  colorClass: string;
  isGem: boolean;
};

const COLOR_CLASSES: string[] = [
  "bg-sbRed",
  "bg-sbPink",
  "bg-sbPink",
  "bg-sbPink",
  "bg-sbPurple",
  "bg-sbPurple",
  "bg-sbYellow",
  "bg-sbTeal",
  "bg-sbIndigo",
  "bg-sbMaroon",
];

const GRAY = "bg-secondary";

const getRandomColorClass = () => {
  return COLOR_CLASSES[Math.floor(Math.random() * COLOR_CLASSES.length)];
};

export default function TheGrid({ rows = 4, cols = 5 }: { rows?: number; cols?: number }) {
  const initialGrid: CellState[] = useMemo(
    () =>
      Array.from({ length: rows * cols }, () => ({
        isActive: false,
        colorClass: "",
        isGem: false,
      })),
    [rows, cols],
  );
  const [grid, setGrid] = useState<CellState[]>(initialGrid);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setGrid((prev) => {
        const next = [...prev];
        const index = Math.floor(Math.random() * next.length);
        const hasAnyGem = next.some((cell) => cell.isGem);
        if (!next[index].isActive) {
          const color = getRandomColorClass();
          next[index] = { isActive: true, colorClass: color, isGem: false };
          if (Math.random() < 0.02 && !hasAnyGem) {
            next[index] = { isActive: true, colorClass: "bg-transparent", isGem: true };
          }
        } else {
          if (Math.random() < 0.75) {
            next[index] = { isActive: false, colorClass: GRAY, isGem: false };
          }
        }
        return next;
      });
    }, 500);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      className={`grid gap-1`}
      style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}
    >
      {grid.map((cell, idx) => (
        <div
          key={idx}
          className={[
            "h-16 w-16 text-[min(8cqw,8cqh)] place-self-center w-fit h-fit leading-none",
            "transition-all duration-500 ease-in-out",
            cell.isActive ? cell.colorClass : GRAY,
            cell.isActive ? "rounded-none" : "rounded-full",
          ].join(" ")}
        >
          <span
            className={[
              "transition-opacity duration-500 ease-in-out",
              cell.isGem ? "opacity-100" : "opacity-0",
            ].join(" ")}
          >
            💎
          </span>
        </div>
      ))}
    </div>
  );
}
